import { render, staticRenderFns } from "./RepackingControlCardScan.vue?vue&type=template&id=23747452&scoped=true&"
import script from "./RepackingControlCardScan.vue?vue&type=script&lang=js&"
export * from "./RepackingControlCardScan.vue?vue&type=script&lang=js&"
import style0 from "./RepackingControlCardScan.vue?vue&type=style&index=0&id=23747452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23747452",
  null
  
)

export default component.exports